import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardActionArea, CardContent, CardMedia, Typography } from '@mui/material';
import './Categoria.css';

const Categoria = ({ setting }) => {
  if (!setting || !setting.Id) {
    return null; // Retorna null si no hay datos de la categoría
  }

  return (
    <Card sx={{ minWidth: 150 }} className="CatOpt">
      <CardActionArea
        component={Link}
        to={`/VerCat/${setting?.Id}`}
        className="CardActionArea"
        sx={{ textDecoration: 'none' }} // Para quitar subrayado en el link
      >
        <CardMedia
          component="img"
          image={setting?.Logo?.Url || 'default-image-url.jpg'} // Fallback si no hay imagen
          alt={setting?.Nom || 'Categoría'} // Fallback si no hay nombre
          className="CatOptMedia"
          sx={{
            width: '72%', // Asegura que la imagen ocupe el 60% de la tarjeta
            objectFit: 'contain', // Asegura que la imagen se vea completa
          }}
        />
        <CardContent
          sx={{
            backgroundColor: '#f5f5f5',
            padding: '5px',
            textAlign: 'center',
            height: '40%', // Asegura que el contenido ocupe el 40% de la tarjeta
          }}
          className="CatOptContent"
        >
          <Typography
            variant="body2"
            color="textSecondary"
            component="span"
            sx={{ fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {setting?.Nom || 'Sin nombre'}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default Categoria;
